import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Returns true if the URL is a real image (not empty, not just the API base) */
export function isValidImageUrl(url: string): boolean {
  return !!url && (url.startsWith('http') || url.startsWith('data:')) && !url.endsWith('api.isentinel360.com') && !url.endsWith('api.isentinel360.com/');
}
